import React, { useCallback } from "react";
import { makePaginatedGet } from "@culturehq/client";

import Slideshow from "components/common/Slideshow";
import EventCard from "components/common/EventCard";

const EventSlides = ({ options }) => {
  const onFetch = useCallback(
    async () => {
      const { events } = await makePaginatedGet("events", "/events", options);
      return events.filter(event => !event.cancelledAt);
    },
    [options]
  );

  return (
    <Slideshow onFetch={onFetch}>
      {event => (
        <div className="Events">
          <EventCard actionable={false} event={event} inList />
        </div>
      )}
    </Slideshow>
  );
};

export default EventSlides;
